import React from 'react';
import block from 'bem-cn';

import Modal from 'components/Modal';

import './CashiersTournament3Modal.scss';
import { shallowEqual, useSelector } from 'react-redux';

const b = block('cashiers-tournament3-modal');

const CashiersTournament3Modal = ({ onClose }) => {
  const { cashiersTournament2: locale } = useSelector(state => state.locale.locale, shallowEqual);

  const content = (
    <div className={b()}>
      <div className={b('title')}>Conditions</div>
      <div className={b('text')}>
        <div>{locale.conditions.cond1}</div>
        <div>{locale.conditions.cond2}</div>
        <div>{locale.conditions.cond3}</div>
        <div>{locale.conditions.cond4}</div>
      </div>
    </div>
  );

  return <Modal onClose={onClose}>{content}</Modal>;
};

export default CashiersTournament3Modal;
